import { render, staticRenderFns } from "./QuantityBox.vue?vue&type=template&id=0222887b"
import script from "./QuantityBox.vue?vue&type=script&lang=js"
export * from "./QuantityBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports